const INITIAL_STATE = {
  blogs: [],
  blogObj: null,
};

const setBlogsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ALL_BLOGS":
      return { ...state, blogs: [...action.payload] };
    case "GET_SINGLE_BLOG":
      return { ...state, blogObj: action.payload };
    case "UPDATE_BLOG":
      const updatedBlogsArray = state.blogs.map((blog) => {
        if (blog.id == action.payload.id) {
          return action.payload;
        } else {
          return blog;
        }
      });
      return { ...state, blogs: [...updatedBlogsArray] };
    case "DELETE_BLOG":
      const filteredBlogsArray = state.blogs.filter(
        (blog) => blog.id !== action.payload
      );
      return { ...state, blogs: [...filteredBlogsArray] };
    default:
      return { ...state };
  }
};
export default setBlogsReducer;
